<template>
  <div class="resources-component">
    <table class="table table-zebra">
      <thead class="table__head">
        <tr class="table__row">
          <th class="table__cell  table__hcell" style="width: 15%;">{{ getTranslation('category') }}</th>
          <th class="table__cell  table__hcell" style="width: 15%;">{{ getTranslation('title') }}</th>
        </tr>
      </thead>
      <tbody class="table__body">
        <tr v-for="item in structureResources" v-bind:key="item.id" class="table__row">
          <td class="table__cell">
            {{ item.resource.type.title }}
          </td>
          <td class="table__cell">
            <router-link :to="{name:'api.nrk.resource.get',params:{id:item.resource.id}}" v-if="item.resource.type.id === RESOURCE_NRK_ID"> {{ item.resource.title }} <span v-if="item.resource.resourceTitle"> ( {{ item.resource.resourceTitle }} )</span></router-link>
            <p class="text" v-if="item.resource.type.id !== RESOURCE_NRK_ID">{{ item.resource.title }} <span v-if="item.resource.resourceTitle"> ( {{ item.resource.resourceTitle }} )</span></p>
          </td>
        </tr>
      </tbody>
    </table>
    <!--  resource modal  -->
    <modal
        v-model="showModal"
        :modal-title="getTranslation('edit')"
        :ok-button-label="getTranslation('save')"
        :cancel-button-label="getTranslation('cancel')"
        @ok-button-click="saveResource"
        @cancelButtonClick="resetResource"
    >
      <span class="text-danger">* {{ getTranslation('required') }}</span>

      <div v-if="loadSelects" class="form__group">
        <label class="form__label  form__label--block">{{ getTranslation('resourceType') }} <span class="required">*</span></label>
        <v-select
            v-model="resourceType"
            :options="formOptions.resourceTypes"
            :reduce="option=>option.id"
            label="title"
            :class="{'field--error': $v.resourceType.$error}"
            :placeholder="getTranslation('selectFromList')"
        />
        <div v-if="$v.resourceType.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
      </div>
      <div v-if="resourceType === RESOURCE_LOCAL_POSITIONS_ID" class="form__group">
        <LocalStateSelect v-model="stateId" :edit-state-id="stateId" />

        <div v-if="showPositions" class="form__group">
          <label class="form__label  form__label--block">{{ getTranslation('resource') }} <span class="required">*</span></label>
          <v-select
              v-model="resource"
              :options="resources"
              label="positionName"
              :placeholder="getTranslation('selectFromList')"
          />
        </div>
      </div>
      <div v-if="resourceType === RESOURCE_EKYZMAT_ID" class="form__group">

        <StateSelect
            ref="stateSelect"
            :initialValue='[null, hrm.departmentId]'
            :department-id.sync="hrm.departmentId"
            :required="true"
        />
        <div v-if="showPositions" class="form__group">
          <label class="form__label  form__label--block">{{ getTranslation('position') }}<span class="required">*</span></label>
          <v-select
              v-model="resource"
              :placeholder="getTranslation('selectFromList')"
              label="positionName"
              :options="formOptions.positions"
              :class="{'field--error': $v.resource.id.$error}"
          />
          <div v-if="$v.resource.id.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
        </div>
      </div>
      <div v-if="resourceType === RESOURCE_CATEGORIES_ID" class="form__group">

        <div class="form__group">
          <label class="form__label  form__label--block">{{ getTranslation('resource') }}<span class="required">*</span></label>
          <v-select
              v-model="resource"
              :placeholder="getTranslation('selectFromList')"
              label="title"
              :options="resources"
          />
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import structureMixin from '../mixins/structure';
import LocalStateSelect from '../../../../components/shared/LocalStateSelect';
import StateSelect from '../../../../components/shared/StateSelect';

export default {
  name: 'ResourcesComponent',
  components: { StateSelect, LocalStateSelect },
  mixins: [ structureMixin ],
  props: {
    structureResources: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showModal: false,
      loadSelects: false,
      showPositions: false,
      stateId: '',
    };
  },
  created() {

  },
  methods: {
    resetResource() {
      this.resource.id = '';
      this.resource.resourceType = '';
      this.resource.resourceId = '';
      this.showModal = false;
    },
    editResource( item ) {
      this.resource.id = item.resource.id;
      this.resource.resourceType = item.resource.resourceType;
      this.resourceType = item.resource.resourceType;
      this.resource.resourceId = item.resource.resourceId;
      this.resource.title = item.resource.title;
      this.resource.stateId = item.resource.stateId;
      this.showModal = true;
    },
    saveResource() {

    },
  },
};
</script>

<style scoped>

</style>
